<template>
<div>
  <b-container>
    <b-row class="d-flex align-items-center" style="width: 100%;
    margin-bottom: 1%;">
    <!-- <b-btn type="button" class="close ffClose" aria-label="Close"
    @click="close()">
      <span aria-hidden="true">&times;</span>
    </b-btn>    -->
      <b-card-group>
        <b-col cols="3" align-self="center">
          <b-btn
            @click="getCardID"
            class="parent"
            variant="link"
            :to="{ path: '/bio-acoustic-demo' }"
            target="_blank"
          >
            <b-card
              class="child"
              no-body
              :img-src="bioAcousticSonarImg"
              img-alt="Image"
              img-top
              tag="article"
            >
              <p
                id="homepage_bioAcousticSonar_card"
                class="card-title nested"
              >Bio-Acoustic Sonar Demonstration</p>
            </b-card>
          </b-btn>
        </b-col>
        <b-col cols="3" align-self="center">
          <b-btn
            @click="getCardID"
            class="parent"
            variant="link"
            :href="realtime_url"
            target="_blank"
          >
            <b-card
              class="child"
              no-body
              :img-src="realTimeImg"
              img-alt="Image"
              img-top
              tag="article"
            >
              <p
                id="homepage_realtime_card"
                class="card-title nested"
              >Real-time Demonstration</p>
            </b-card>
          </b-btn>
        </b-col>
      </b-card-group>
    </b-row>
    <hr class="my-4">
  </b-container>
</div>
</template>
<script>
import bioAcousticSonarImg from
  '../../assets/img/landingpage-img/bioAcousticSonarImg.png';
import realTimeImg from '../../assets/img/landingpage-img/realTimeImg.png';

export default {
  data() {
    return {
      bioAcousticSonarImg,
      realTimeImg,
      realtime_url: `${process.env.OOIURL}/realtime-ctd-test/`,
    };
  },
  methods: {
    getCardID(event) {
      this.$ga('event', event.target.id);
    },
  },
};
</script>
